import { render } from "./BulkDatabaseElementView.vue?vue&type=template&id=77a5e14a&ts=true"
import script from "./BulkDatabaseElementView.vue?vue&type=script&lang=ts"
export * from "./BulkDatabaseElementView.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__